import { useQuery } from '@tanstack/react-query'
import { adminService, Language } from '../services/adminService'

export function useLanguages() {
  const {
    data: languages = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['languages'],
    queryFn: () => adminService.getLanguages(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })

  return {
    languages,
    isLoading,
    error,
    refetch
  }
}

export function useAllLanguages() {
  const {
    data: languages = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['all-languages'],
    queryFn: () => adminService.getAllLanguages(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })

  return {
    languages,
    isLoading,
    error,
    refetch
  }
}

// Helper function to convert database Language to the format used by translation components
export function convertToTranslationFormat(languages: Language[]) {
  return languages.map(lang => ({
    code: lang.code,
    name: lang.name,
    flag: lang.flag
  }))
} 